import React from "react";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import store from "./store";
import { Provider } from "react-redux";
// Import Routes
import { authenticatedUserRoutes, publicRoutes, superUserRoutes } from "./routes/allRoutes";
// Import all middleware
import Authmiddleware from "./routes/middleware/Authmiddleware";
// Import layouts and screens
import NonAuthLayout from "./components/layout/NonAuthLayout.component";
import AuthLayout from "./components/layout/Layout.component";
import NotFoundScreen from "./screens/NotFoundScreen";

import 'react-responsive-modal/styles.css';
import './assets/css/styles.css';
import './assets/css/rolePermissionDrawer.css';


const App = () => (
  <Provider store={store}>
    <Router>
      <Routes>
        {publicRoutes?.map((route, idx) => (
          <Route
            key={idx}
            path={route.path}
            element={
              <Authmiddleware
                layout={route.layout || NonAuthLayout}
                component={route.component}
                isAuthProtected={false}
                isSuperUserProtected={false}
              />
            }
          />
        ))}
        
        <Route
          path="/*"
          element={
            <AuthLayout
              content={
                <Routes>
                  {authenticatedUserRoutes?.map((route, idx) => (
                    <Route
                      key={idx}
                      path={route.path}
                      element={
                        <Authmiddleware
                          component={route.component}
                          isAuthProtected={true}
                        />
                      }
                    />
                  ))}
                  {superUserRoutes?.map((route, idx) => (
                    <Route
                      key={idx}
                      path={route.path}
                      element={
                        <Authmiddleware
                          component={route.component}
                          isSuperUserProtected={true}
                        />
                      }
                    />
                  ))}
                  <Route path="*" element={<NotFoundScreen />} />
                </Routes>
              }
            />
          }
        />
      </Routes>
    </Router>
  </Provider>
);

export default App;
